/**
 * Settings → Theme (web.md §4, §7): Appearance · Custom theme · Reading, the prototype's three records.
 * Each record is an editor over the synced settings (`settings.get / set`); see editors.tsx and
 * CustomThemeEditor.tsx.
 */

import { useEntitlement, useSettings } from '../../app/hooks.js';
import { EditorEmpty, type ItemsResult, type SettingsCategory, type SettingsEditorProps } from '../shell/index.js';
import { CustomThemeEditor } from './CustomThemeEditor.js';
import { AppearanceEditor, ReadingEditor } from './editors.js';

const ITEMS = [
  { id: 'appearance', name: 'Appearance', icon: 'sun' },
  { id: 'custom', name: 'Custom theme', icon: 'palette' },
  { id: 'reading', name: 'Reading', icon: 'eye' },
];

function useItems(): ItemsResult {
  return { items: ITEMS, isLoading: false, error: null };
}

function ThemeEditor({ recordId }: SettingsEditorProps) {
  const settings = useSettings();
  const entitlement = useEntitlement();
  if (!settings || !entitlement) return <EditorEmpty text="Loading…" />;
  if (recordId === 'appearance') return <AppearanceEditor settings={settings} entitlement={entitlement} />;
  if (recordId === 'custom') return <CustomThemeEditor settings={settings} entitlement={entitlement} />;
  if (recordId === 'reading') return <ReadingEditor settings={settings} entitlement={entitlement} />;
  return <EditorEmpty />;
}

export const category: SettingsCategory = { id: 'theme', name: 'Theme', icon: 'sun', useItems, Editor: ThemeEditor };
